import script from "./TimelineScorecardTotalTime.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimelineScorecardTotalTime.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItemLabel});
